import type { ReactNode } from "react";
import { Checkbox } from "@shared-kernel/primary/shared/shadcn/ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@shared-kernel/primary/shared/shadcn/ui/select";
import { cn } from "@shared-kernel/primary/shared/shadcn/utils/utils";
import type { TimeIntervalSelectProps } from "./training-schedule-form.types";

export const TimeIntervalSelect = ({
  label,
  enabled,
  startValue,
  endValue,
  startOptions,
  endOptions,
  onStartChange,
  onEndChange,
  onToggle,
  children,
}: TimeIntervalSelectProps & { children?: ReactNode }) => {
  return (
    <div className="flex items-center gap-3">
      <Checkbox checked={enabled} onCheckedChange={onToggle} aria-label={label} />
      <span className="w-24 cursor-pointer text-sm font-medium" onClick={onToggle}>
        {label}
      </span>

      <div className={cn("flex flex-1 items-center gap-2", !enabled && "pointer-events-none opacity-50")}>
        <Select value={startValue} onValueChange={onStartChange} disabled={!enabled}>
          <SelectTrigger className="w-24">
            <SelectValue placeholder="Début" />
          </SelectTrigger>
          <SelectContent>
            {startOptions.map(option => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <span className="text-muted-foreground">-</span>

        <Select value={endValue} onValueChange={onEndChange} disabled={!enabled}>
          <SelectTrigger className="w-24">
            <SelectValue placeholder="Fin" />
          </SelectTrigger>
          <SelectContent>
            {endOptions.map(option => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        {children}
      </div>
    </div>
  );
};
